import $ from "jquery";

export const SetupProfilePhoto = function () {
	if (!($("#setup-profile-photo").length > 0)) return false;

	const $elms = {
		page: $("#setup-profile-photo"),
		form: $("#setup-profile-form"),
		uploadPhoto: $(".js-upload-photo"),
		removePhoto: $(".js-remove-photo"),
		saveProfile: $(".js-save-profile"),
		photo: $("#setup-profile-photo-image"),
		cameraInput: $(
			'<input type="file" accept="image/*" capture="environment" style="display: none;">',
		),
		galleryInput: $(
			'<input type="file" accept="image/*" style="display: none;">',
		),
	};

	// Get the default photo URL from the current img src
	const defaultPhotoUrl = $elms.photo.attr("src");
	let selectedPhotoFile = null; // Store the selected file

	// Append hidden file inputs to form
	$elms.form.append($elms.cameraInput);
	$elms.form.append($elms.galleryInput);

	const validateImageFile = (file) => {
		const validTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
		const maxSize = 15 * 1024 * 1024; // 15MB

		if (!validTypes.includes(file.type)) {
			alert("Please select a valid image file (JPEG, PNG, GIF, or WebP)");
			return false;
		}

		if (file.size > maxSize) {
			alert("Image file size must be less than 15MB");
			return false;
		}

		return true;
	};

	const validateForm = () => {
		const isValid = $elms.cameraInput.val() || $elms.galleryInput.val();
		$elms.saveProfile.prop("disabled", !isValid);
		return isValid;
	};

	// Initial validation
	validateForm();

	// Create custom photo source modal
	const createPhotoSourceModal = () => {
		const modal = $(`
			<div class="photo-source-modal" style="
				position: fixed;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				z-index: 10000;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 20px;
				box-sizing: border-box;
			">
				<div class="photo-source-modal__content" style="
					background: white;
					border-radius: 12px;
					padding: 24px;
					max-width: 320px;
					width: 100%;
					text-align: center;
					box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
				">
					<h3 style="
						margin: 0 0 16px 0;
						font-size: 18px;
						font-weight: 600;
						color: #333;
					">${window.CFG.strings.photoSourceTitle}</h3>
					<p style="
						margin: 0 0 24px 0;
						color: #666;
						font-size: 14px;
					">${window.CFG.strings.photoSourceDescription}</p>
					<div style="
						display: flex;
						flex-direction: column;
						gap: 12px;
					">
						<button class="photo-source-btn photo-source-btn--camera" style="
							background: #007cba;
							color: white;
							border: none;
							padding: 12px 24px;
							border-radius: 8px;
							font-size: 16px;
							font-weight: 500;
							cursor: pointer;
							transition: background-color 0.2s;
						">
							📷 ${window.CFG.strings.takePhotoText}
						</button>
						<button class="photo-source-btn photo-source-btn--gallery" style="
							background: #f0f0f0;
							color: #333;
							border: none;
							padding: 12px 24px;
							border-radius: 8px;
							font-size: 16px;
							font-weight: 500;
							cursor: pointer;
							transition: background-color 0.2s;
						">
							🖼️ ${window.CFG.strings.chooseFromGalleryText}
						</button>
						<button class="photo-source-btn photo-source-btn--cancel" style="
							background: transparent;
							color: #666;
							border: 1px solid #ddd;
							padding: 12px 24px;
							border-radius: 8px;
							font-size: 16px;
							font-weight: 500;
							cursor: pointer;
							transition: background-color 0.2s;
						">
							${window.CFG.strings.cancelText}
						</button>
					</div>
				</div>
			</div>
		`);

		// Add hover effects
		modal.find(".photo-source-btn").hover(
			function () {
				if ($(this).hasClass("photo-source-btn--camera")) {
					$(this).css("background-color", "#005a87");
				} else if ($(this).hasClass("photo-source-btn--gallery")) {
					$(this).css("background-color", "#e0e0e0");
				} else if ($(this).hasClass("photo-source-btn--cancel")) {
					$(this).css("background-color", "#f8f8f8");
				}
			},
			function () {
				if ($(this).hasClass("photo-source-btn--camera")) {
					$(this).css("background-color", "#007cba");
				} else if ($(this).hasClass("photo-source-btn--gallery")) {
					$(this).css("background-color", "#f0f0f0");
				} else if ($(this).hasClass("photo-source-btn--cancel")) {
					$(this).css("background-color", "transparent");
				}
			},
		);

		return modal;
	};

	$elms.uploadPhoto.on("click", function () {
		// Check if we're on a mobile device
		const isMobile =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent,
			);

		if (isMobile) {
			// Show custom modal for mobile
			const modal = createPhotoSourceModal();
			$("body").append(modal);

			// Handle button clicks
			modal.find(".photo-source-btn--camera").on("click", function () {
				modal.remove();
				$elms.cameraInput.trigger("click");
			});

			modal.find(".photo-source-btn--gallery").on("click", function () {
				modal.remove();
				$elms.galleryInput.trigger("click");
			});

			modal.find(".photo-source-btn--cancel").on("click", function () {
				modal.remove();
			});

			// Close modal when clicking outside
			modal.on("click", function (e) {
				if (e.target === modal[0]) {
					modal.remove();
				}
			});
		} else {
			// Desktop - use gallery input
			$elms.galleryInput.trigger("click");
		}
	});

	const handleFileChange = function (e) {
		const file = e.target.files[0];
		if (file && validateImageFile(file)) {
			selectedPhotoFile = file; // Store the valid file
			const reader = new FileReader();
			reader.onload = function (e) {
				$elms.photo.attr("src", e.target.result);
				$elms.photo.closest(".setup__photo").addClass("is-image-uploaded");
				validateForm(); // Revalidate after photo upload
			};
			reader.readAsDataURL(file);
		} else {
			selectedPhotoFile = null; // Clear stored file if invalid
			$elms.cameraInput.val(""); // Clear the invalid file
			$elms.galleryInput.val(""); // Clear the invalid file
			validateForm(); // Revalidate after failed upload
		}
	};

	$elms.cameraInput.on("change", handleFileChange);
	$elms.galleryInput.on("change", handleFileChange);

	$elms.removePhoto.on("click", function () {
		selectedPhotoFile = null; // Clear stored file
		$elms.photo.attr("src", defaultPhotoUrl);
		$elms.photo.closest(".setup__photo").removeClass("is-image-uploaded");
		$elms.cameraInput.val(""); // Clear the camera input
		$elms.galleryInput.val(""); // Clear the gallery input
		validateForm(); // Revalidate after photo removal
	});

	$elms.form.on("submit", function (e) {
		e.preventDefault();

		const photoFile = selectedPhotoFile; // Get the actual File object

		if (!photoFile) {
			alert("All fields are required");
			return;
		}

		// Create FormData object for file upload
		const formData = new FormData();
		formData.append("action", "setup_profile_photo");
		formData.append("photo", photoFile);
		formData.append("nonce", window.CFG.nonce);
		formData.append("user_id", $elms.page.attr("data-user-id"));

		// Disable form during submission
		$elms.saveProfile.prop("disabled", true);
		$elms.saveProfile.addClass("is-loading");

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: formData,
			processData: false, // Don't process the data
			contentType: false, // Don't set content type
			success: function (response) {
				if (response.success) {
					// Handle success - maybe redirect or show success message
					if (response.data.user_id) {
						window.location.href = `${window.CFG.siteURL}/setup-password/${response.data.user_id}`;
					}
				} else {
					// Handle error from server
					alert(
						response.data?.message ||
							"Failed to setup profile. Please try again.",
					);
				}
			},
			error: function (xhr, status, error) {
				console.error(error);
				alert("Failed to setup profile. Please try again.");
			},
			complete: function () {
				// Re-enable form after submission
				$elms.saveProfile.prop("disabled", false);
				$elms.saveProfile.removeClass("is-loading");
			},
		});
	});
};
